<template>
  <span
    class="d-leaderboard-feed-entry-badge"
    :class="getBadgeClass()"
  >#{{ position }}</span>
</template>

<script>
export default {
  props: {
    position: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getBadgeClass() {
      if (this.position === 1) return 'gold';
      if (this.position === 2) return 'silver';
      if (this.position === 3) return 'bronze';

      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-leaderboard-feed-entry-badge {
  align-items: center;
  background-color: getColor($white);
  border-radius: $_2-5em;
  border: 1px solid getColor($white);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  left: -$_1em;
  line-height: 1;
  min-width: $_5em;
  min-height: $_5em;
  position: absolute;
  padding: $_1em;
  top: -$_1em;

  &.gold {
    background-color: getColor($positions, gold);
    color: getColor($white);
  }

  &.silver {
    background-color: getColor($positions, silver);
    color: getColor($white);
  }

  &.bronze {
    background-color: getColor($positions, bronze);
    color: getColor($white);
  }
}
</style>
